export default __webpack_public_path__ + "static/media/ANEXO-I-BENEFICIARIO-BENEFICIARIO-PARTE-RENDIMENTO-ISENTO-NAO-TRIBUTAVEL.daceee05.docx";